import ReactGA from 'react-ga'

export function addProductImpression(products) {
  products.forEach(product => {
    ReactGA.plugin.execute('ec', 'addImpression', product)
  })
  ReactGA.ga('send', 'pageview')
}

export function productClick(product, list, callback) {
  ReactGA.plugin.execute('ec', 'addProduct', product)
  ReactGA.plugin.execute('ec', 'setAction', 'click', { list })
  ReactGA.ga('send', 'event', 'UX', 'click', list, {
    hitCallback: callback,
  })
}

export function productDetailsView(product) {
  ReactGA.plugin.execute('ec', 'addProduct', product)
  ReactGA.plugin.execute('ec', 'setAction', 'detail')
  ReactGA.ga('send', 'pageview')
}

export function addToCartEvent(product) {
  ReactGA.plugin.execute('ec', 'addProduct', product)
  ReactGA.plugin.execute('ec', 'setAction', 'add')
  ReactGA.ga('send', 'event', 'UX', 'click', 'add to cart')
}

export function removeFromCartEvent(product) {
  ReactGA.plugin.execute('ec', 'addProduct', product)
  ReactGA.plugin.execute('ec', 'setAction', 'remove')
  ReactGA.ga('send', 'event', 'UX', 'click', 'remove from cart')
}

export function checkoutStep(products, step, option) {
  products.forEach(product => {
    ReactGA.plugin.execute('ec', 'addProduct', product)
  })

  ReactGA.plugin.execute('ec', 'setAction', 'checkout', { step, option })
  ReactGA.ga('send', 'pageview')
}

export function checkoutStepOptionEvent(step, option) {
  ReactGA.plugin.execute('ec', 'setAction', 'checkout_option', { step, option })
  ReactGA.ga('send', 'event', 'Checkout', 'Option')
}

export function purchase(products, transaction) {
  //ReactGA.ga('set', 'currencyCode', 'EUR');
  products.forEach(product => {
    ReactGA.plugin.execute('ec', 'addProduct', product)
  })
  ReactGA.plugin.execute('ec', 'setAction', 'purchase', transaction)
  ReactGA.ga('send', 'pageview')
}
